import {
  DTableProps,
  CombinedText,
  StatusChip,
  StatusChipColors,
} from '@darwin-ui';
import { TFunction } from 'i18next';
import {
  MassiveTransaction,
  ProcessingStatus,
} from 'types/massiveTransactionTypes';

const statusColorMap: Record<ProcessingStatus, StatusChipColors> = {
  PROCESSING: StatusChipColors.yellow,
  COMPLETED_SUCCESS: StatusChipColors.green,
  COMPLETED_WITH_ERRORS: StatusChipColors.yellow,
  FAILED: StatusChipColors.red,
  PENDING: StatusChipColors.yellow,
  CANCELLED: StatusChipColors.red,
};

export const getMassiveTransactionsColumns = (
  t: TFunction,
  searchQuery: string
): DTableProps<MassiveTransaction>['columns'] => [
  {
    title: t('upload-history.columns.createdAt'),
    dataIndex: 'createdAt',
    key: 'createdAt',
    sorter: true,
    width: 190,
    render: (_: unknown, record: MassiveTransaction) => (
      <CombinedText
        lines={1}
        text={new Date(record.createdAt).toLocaleString()}
        highlight={searchQuery}
      />
    ),
  },
  {
    title: t('upload-history.columns.completedAt'),
    dataIndex: 'completedAt',
    key: 'completedAt',
    sorter: true,
    width: 190,
    render: (_: unknown, record: MassiveTransaction) => (
      <CombinedText
        lines={1}
        text={
          record.completedAt
            ? new Date(record.completedAt).toLocaleString()
            : '—'
        }
        highlight={searchQuery}
      />
    ),
  },
  {
    title: t('upload-history.columns.processName'),
    dataIndex: 'processName',
    key: 'processName',
    sorter: true,
    render: (_: unknown, record: MassiveTransaction) => (
      <CombinedText
        lines={1}
        text={record.processName}
        highlight={searchQuery}
      />
    ),
  },
  {
    title: t('upload-history.columns.formName'),
    dataIndex: 'formName',
    key: 'formName',
    sorter: true,
    width: 200,
    render: (_: unknown, record: MassiveTransaction) => (
      <CombinedText lines={1} text={record.formName} highlight={searchQuery} />
    ),
  },
  {
    title: t('upload-history.columns.processMapName'),
    dataIndex: 'processMapName',
    key: 'processMapName',
    sorter: true,
    width: 260,
    render: (_: unknown, record: MassiveTransaction) => (
      <CombinedText
        lines={1}
        text={record.processMapName || ''}
        highlight={searchQuery}
      />
    ),
  },
  {
    title: t('upload-history.columns.fileName'),
    dataIndex: 'metadata.fileName',
    key: 'metadata.fileName',
    width: 180,
    render: (_: unknown, record: MassiveTransaction) => (
      <CombinedText
        lines={1}
        text={record.metadata.filename}
        highlight={searchQuery}
      />
    ),
  },
  {
    title: t('upload-history.columns.status'),
    dataIndex: 'processingStatus',
    key: 'processingStatus',
    render: (_: unknown, record: MassiveTransaction) => (
      <StatusChip
        label={t(
          `upload-history.status.${record.processingStatus
            .toLowerCase()
            .replaceAll('_', '-')}`
        )}
        color={statusColorMap[record.processingStatus]}
      />
    ),
  },
  {
    title: t('upload-history.columns.totalRecords'),
    dataIndex: 'totalRecords',
    key: 'totalRecords',
    render: (_: unknown, record: MassiveTransaction) => (
      <CombinedText
        lines={1}
        text={String(record.totalRecords)}
        highlight={searchQuery}
      />
    ),
  },
  {
    title: t('upload-history.columns.successfulRecords'),
    dataIndex: 'successfulRecords',
    key: 'successfulRecords',
    render: (_: unknown, record: MassiveTransaction) => (
      <CombinedText
        lines={1}
        text={String(record.successfulRecords)}
        highlight={searchQuery}
      />
    ),
  },
];
